// /src/pages/Home.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { getLangFromPath } from "../i18n/lang";

import HomeUk from "./static/Home.uk.jsx";
import HomeEn from "./static/Home.en.jsx";
import HomeIt from "./static/Home.it.jsx";
import HomeFr from "./static/Home.fr.jsx";

export default function Home(props) {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname);
  const Map = { uk: HomeUk, en: HomeEn, it: HomeIt, fr: HomeFr };

  const L = Map[lang] || HomeUk;
  return <L {...props} />;
}
